import { ASYNC_STATUS_ID } from 'constants'
import { API } from 'constants/apiEndPoints'
import { EVENTS } from 'constants/events'
import { getAchievementLevelUIData } from 'constants/user/userLevels'
import { useEffect, useState } from 'react'
import { useCustomEventListener } from 'react-custom-events'
import { useAPI } from 'utils/hooks/useAPI'

const DATA_INIT = {
  loading: true,
  achievementList: [],
}

const DIFFICULTY_GOAL_ORDER = ['Super Easy', 'Easy', 'Beginner', 'Medium', 'Expert', 'Degen Master']

const sortByDifficultyByXp = (arr, orderDifficulty) => {
  const orderDifficultyMap = new Map(orderDifficulty.map((item, index) => [item, index]))
  return arr.sort((a, b) => {
    const difficultyComparison = orderDifficultyMap.get(a.difficulty) - orderDifficultyMap.get(b.difficulty)
    if (difficultyComparison !== 0) return difficultyComparison
    else return a.xp - b.xp
  })
}

export const useUserAchievementData = () => {
  const [data, setData] = useState(DATA_INIT)
  const [achievementDataState, getAchievementData, hasAchievementDataStatus] = useAPI(API.ACHIEVEMENT_USER, {
    queryType: 'get',
    controlled: true,
    withJwt: true,
  })

  const fetchAchievementData = () => {
    setData((prev) => ({ ...prev, loading: true }))
    getAchievementData()
  }

  useEffect(() => {
    fetchAchievementData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useCustomEventListener(EVENTS.USER_ACHIEVEMENT_NEW, fetchAchievementData)

  useEffect(() => {
    if (hasAchievementDataStatus(ASYNC_STATUS_ID.ERROR)) {
    }

    if (hasAchievementDataStatus(ASYNC_STATUS_ID.CONFIRMED)) {
      const achievementInfo = achievementDataState.data
      const achievementRawList = achievementInfo.achievementList.filter((item) => !!item.name)
      const achievementList = sortByDifficultyByXp(achievementRawList, DIFFICULTY_GOAL_ORDER)

      const achievementsLevel = achievementInfo.achievementsLevel
        .filter((item) => !!item.level)
        .map((item) => ({ ...item, ...getAchievementLevelUIData(item.level) }))

      const achievementUser = {
        ...achievementInfo.userInfo,
        ...getAchievementLevelUIData(achievementInfo.userInfo.level),
        nextLevelInfo: achievementsLevel
          .filter((item) => item.xp_requirement > achievementInfo.userInfo.totalPoint)
          .sort((a, b) => a.xp_requirement - b.xp_requirement)
          .at(0),
      }
      setData((prev) => ({ ...prev, achievementUser, achievementsLevel, achievementList, loading: false }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [achievementDataState.status?.id, achievementDataState?.data])

  return data
}
